import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { of, Observable, map, catchError } from 'rxjs';
import { AppState } from '../store/app.states';
import { loadPredictionDetails } from '../store/actions/prediction.actions';
import { PredictionService } from '../services/prediction.service';


export const detailsGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
  const store = inject(Store<AppState>);
  const predictionService = inject(PredictionService);
  const predictionId = route.paramMap.get('id');

  if (!predictionId) {
    console.warn('No prediction ID in route');
    return of(false); // cancel navigation
  }
  const userId = JSON.parse(localStorage.getItem('user') || '{}').user_id;
  store.dispatch(loadPredictionDetails({ predictionId: predictionId, userId: userId }));

  return of(true)
};
